
<template lang="pug">
q-page.fit
  .q-pa-lg.column.items-center
    q-btn.q-mt-lg(@click="onTestLog") テスト: PHPログ出力
    q-btn.q-mt-lg(@click="onTestException") テスト: PHP例外発生
    q-btn.q-mt-lg(@click="onTestJavascriptException") テスト: Javascript例外発生
    q-btn.q-mt-lg(@click="onTestStacktrace") テスト: スタックトレース
    q-btn.q-mt-lg(@click="onTestAjaxExceptionWithCatch") テスト: ajaxエラー例外発生 (catchあり)
    q-btn.q-mt-lg(@click="onTestAjaxExceptionWithoutCatch") テスト: ajaxエラー例外発生 (catchなし)
</template>

<script>
import AxiosMixin from 'mixins/axios'

import StackTrace from 'stacktrace-js'

export default {
  mixins: [AxiosMixin],

  methods: {
    async onTestLog() {
      try {
        await this.axios.put('/api/test/log')
        this.$q.notify('テスト: PHPログ出力 実行済み')
      }
      catch(e) {this.$handler(e)}
    },

    async onTestException() {
      try {
        await this.axios.put('/api/test/exception')
        this.$q.notify('テスト: PHP例外発生 実行済み')
      }
      catch(e) {this.$handler(e)}
    },

    onTestJavascriptException() {
      this.$q.notify('テスト: Javascript例外発生 実行済み')
      throw new Error("######### テスト: Javascript例外発生 #########")
    },

    async onTestStacktrace() {
      try {
        const stack = await StackTrace.get()
        console.log(stack) // eslint-disable-line no-console
      }
      catch(e) {this.$handler(e)}
    },

    async onTestAjaxExceptionWithCatch() {
      try {
        // await this.axios.get('/kanarazu404')
        throw new Error('######### テスト: ajaxエラー例外発生 (catchあり) #########')
      }
      catch(e) {this.$handler(e)}
    },

    async onTestAjaxExceptionWithoutCatch() {
      // await this.axios.get('/kanarazu404')
      throw new Error('######### テスト: ajaxエラー例外発生 (catchなし) #########')
    },
  },

}
</script>
